var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PoseCanvas',{attrs:{"conditions":[],"image-src":require('@/assets/front.jpg'),"poseDirectionData":_vm.frontStanding}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }